<template>
  <pict
    class="churn-prevention-image__image"
    block-name="churn-prevention-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/desktop.png"
import imageL2x from "./images/desktop@2x.png"
import imageM from "./images/tablet.png"
import imageM2x from "./images/tablet@2x.png"
import imageS from "./images/mobile.png"
import imageS2x from "./images/mobile@2x.png"

export default {
  name: "ChurnPreventionImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageM,
            srcset: {
              "2x": imageM2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with a cone hat cheering and throwing some confetti."
      },
      de: {
        alt: "Eine Person mit einem Hut freut sich und wirft Konfetti."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.churn-prevention-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
